export default "https://housescan.app.solease.nl/static/media/charging_station_2.52f33080.svg";